// GLOBAL STATE MANAGER
/*
 *
 */

const getDefaultState = function () {
    return {
        // Initial state
        userInfo: {
            isLogged: false,
            name: "",
            surname: "",
            username: "",
            email: "",
            phone: "",
            role: "",
            token: "",
            scenarioId: "",
            groupId: ""
        },
        userOptions: {
            contextId: "", // Used for keeping the context (both in chat and in search)
        },
        settings: { // Setting for user with role "admin"
            general: {
                language: {
                    previous: {
                        name: "English",
                        locale: "en",
                        image: require("@/assets/img/settings/flags/en.png"),
                    },
                    current: {
                        name: "English",
                        locale: "en",
                        image: require("@/assets/img/settings/flags/en.png"),
                    },
                }
            },
            chatbot: {
                language: {
                    previous: {
                        name: "Italiano",
                        locale: "it",
                        image: require("@/assets/img/settings/flags/it.png"),
                    },
                    current: {
                        name: "Italiano",
                        locale: "it",
                        image: require("@/assets/img/settings/flags/it.png"),
                    },
                },
                audio: {
                    enable: {
                        previous: false,
                        current: false
                    },
                    language: {
                        previous: {
                            name: "English",
                            locale: "en",
                            image: require("@/assets/img/settings/flags/en.png"),
                        },
                        current: {
                            name: "English",
                            locale: "en",
                            image: require("@/assets/img/settings/flags/en.png"),
                        },
                    }
                },
                engine: {
                    previous: {
                        name: "Dialog Flow",
                        image: require("@/assets/img/chatbot/engine/google-dialogflow.png"),
                    },
                    current: {
                        name: "Dialog Flow",
                        image: require("@/assets/img/chatbot/engine/google-dialogflow.png"),
                    },
                },
                enableAdvanced: {
                    previous: false,
                    current: false,
                },
                enableWikipedia: {
                    previous: false,
                    current: false,
                },
                enableConsole: {
                    previous: true,
                    current: true,
                }
            },
            files: {
                pdfViewer: false,
            },
            classification: {},
            email: {
                enableEmailRouting: {
                    previous: true,
                    current: true,
                },
            },
            web: {
                enableWebInformationRetrieval: {
                    previous: true,
                    current: true,
                },
            },
            imageCaptioning: {
                enableImageCaptioning: {
                    previous: false,
                    current: false,
                },
            },
            settingsFilter: [],
        },
        globalNotifications: [],
    };
};

const state = getDefaultState();


const getters = {
    getUserInfo: (state) => {
        return state.userInfo;
    },
    getUserOptions: (state) => {
        return state.userOptions;
    },
    getSettings: (state) => {
        return state.settings;
    },
    getGlobalNotifications: (state) => {
        return state.globalNotifications;
    },
    getGlobalNotificationsNotDismissed: (state) => {
        return state.globalNotifications.filter(notification => !notification.dismissed);
    },
};

const actions = {
    resetState({commit,}) {
        commit("resetState");
    },
    setUserInfo({commit, state}, userInfoState) {
        commit("setUserInfo", userInfoState);
    },
    setUserOptions({commit, state,}, userOptionsState) {
        commit("setUserOptions", userOptionsState);
    },
    setSettings({commit, state,}, settingsState) {
        commit("setSettings", settingsState);
    },
    setGlobalNotifications({commit, state,}, globalNotificationsState) {
        commit("setGlobalNotifications", globalNotificationsState);
    },
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setUserInfo(state, userInfoState) {
        state.userInfo = userInfoState;
        //console.log('UserState -> New login user mutation: ', state.userInfo);
    },
    setUserOptions(state, userOptionsState) {
        state.userOptions = userOptionsState;
        //console.log('UserState -> userOptions: ', state.userOptions);
    },
    setSettings(state, settingsState) {
        state.settings = settingsState;
        //console.log('UserState -> settings: ', state.settings);
    },
    setGlobalNotifications(state, globalNotificationsState) {
        state.globalNotifications = globalNotificationsState;
        //console.log('UserState -> setGlobalNotifications: ', state.globalNotifications);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
